
import { defineStore } from 'pinia'
import { computed } from 'vue'
import { format } from 'date-fns';


import { useStoryBlokStore } from "./storyblok";

export const useMetadataStore = defineStore('metadata', () => {

  const storyBlockStore = useStoryBlokStore();

  const conferenceDate = computed(() => {

    if(storyBlockStore.metadata === undefined) return undefined;

    const date = storyBlockStore.metadata.conference_date
    return format(new Date(date), 'd. M. yyyy')
  });

  const attendeesCount = computed(() => {
    if(storyBlockStore.metadata === undefined) return undefined;

    return storyBlockStore.metadata.attendees_count;
  });

  const lecturesCount = computed(() => {
    if(storyBlockStore.metadata === undefined) return undefined;

    return storyBlockStore.metadata.lectures_count;
  });

  const videoInvitationUrl = computed(() => {
    if(storyBlockStore.metadata === undefined) return undefined;

    return storyBlockStore.metadata.video_invitation_url;
  });

  const metadata = computed(() => {
    if(storyBlockStore.metadata === undefined) return undefined;

    return storyBlockStore.metadata;
  });

  return { conferenceDate, metadata, attendeesCount, lecturesCount, videoInvitationUrl }
})
